import { Box, Button, Grid, TextField, Typography, FormControl, Select, MenuItem } from '@mui/material'
import React, {useState, useEffect} from 'react'
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/system';
import { linguaT } from "../helpers/linguaT";


function Form(props) {
  const { email, whatsapp, color, lang } = props
  const [ready, setReady] = useState(false)
  const [name, setName] = useState("")
  const [review, setReview] = useState("")
  const [choice, setChoice] = useState(0)
  const selected_lang = lang;

  useEffect(() => {
    setReady(
      name.length > 2 &&
      review.length > 5 
    )
  }, [name, review]);

  useEffect(()=>{
    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    if (isMobile) {
      setChoice(1)
    }
  }, [])

  const handleSend = () =>{
    switch (choice) {
      case 0:
        window.location.href = "mailto:" + email + "?subject=Recensione&body="+ review
        break; 
    
      case 1:
        const text = encodeURI(linguaT("review", selected_lang, []) + " " + name + ": " + review)
        window.location.href = "https://wa.me/39"+ whatsapp.replace("+","") + "?text=" + text
        break;
      default:
        break;
    }
  }

  const style = {
    root: {
      maxWidth: "350px",
      display: "flex",
      flexDirection: "column",
      m: "auto",
      height: "100%"
    },
    description: {

    },
    form: {
      root:{
        mt:2
      },
      name:{

      },
      mail:{
        my: 2,
      },
      number:{
        my: 2,
        pl: 1

      },
      review:{
        mb: 2
      },
      button: {
        margin: "0 auto",
        px: 4,
        color: "#fff"
      },

      textfield:{
        border: "red 1px"
      }

    }
  }
  

  const theme = createTheme({
    palette: {
      color1: {
        main: color
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Box sx={style.root}>
        <Typography variant="subtitle2" component="p" sx={style.description} align="left">
        { linguaT("form_description", selected_lang, []) }
        </Typography>

        <Grid container sx={style.form.root}>
          <Grid item xs={12}
            sx={style.form.name} 
          >
            <TextField
              type="text"
              fullWidth
              size="small"
              placeholder={ linguaT("your_name_placeholder", selected_lang, []) }
              onChange={(e)=>setName(e.target.value)}
              value={name}
              color="color1"
            />
          </Grid>
          <Grid item xs={12}
            sx={style.form.mail} 
          >
            <FormControl fullWidth>
              <Select
                align="left"
                value={choice}
                size="small"
                onChange={(e)=>setChoice(e.target.value)}
                color="color1"

              >
                <MenuItem value={0}>Email</MenuItem>
                {
                whatsapp !== "" &&  
                <MenuItem value={1}>Whatsapp</MenuItem>
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}
            sx={style.form.review} 
          >
            <TextField
              type="text"
              fullWidth
              size="small"
              multiline
              rows={4}
              placeholder={ linguaT("write_review_placeholder", selected_lang, []) }
              onChange={(e)=>setReview(e.target.value)}
              value={review}
              color="color1"

            />
          </Grid>
          <Button 
            sx={style.form.button} 
            variant="contained"
            disabled={!ready}
            onClick={handleSend}
            color="color1"
          >
            { linguaT("btn_send", selected_lang, []) }
          </Button>

        </Grid>
      </Box>
    </ThemeProvider>
  )
}

export default Form